import { type PropsWithChildren } from 'react';
import Link from 'next/link';
import { MyMenuDropdown } from '@/layout';
import { LogInButton } from '@/layout/Header/UserManagementButton';
import { useUser } from '@/lib/auth';
import { cn } from '@/utils';
export const Header = () => <HeaderContainer data-sentry-element="HeaderContainer" data-sentry-component="Header" data-sentry-source-file="Header.tsx">
    <div className="flex items-center justify-between">
      <Link href="/" data-sentry-element="Link" data-sentry-source-file="Header.tsx">
        <img src="/assets/ZEPQuiz-logo.svg" alt="ZEP QUIZ" className="h-[28px]" />
      </Link>
      <AuthButton data-sentry-element="AuthButton" data-sentry-source-file="Header.tsx" />
    </div>
  </HeaderContainer>;
const HeaderContainer = ({
  className,
  children
}: PropsWithChildren<{
  className?: string;
}>) => <header className={cn('py-[12px] px-[40px] bg-white border-b border-alternative shadow-xs fixed z-40 w-full', className)} data-sentry-component="HeaderContainer" data-sentry-source-file="Header.tsx">
    {children}
  </header>;
const AuthButton = () => {
  const {
    user,
    isInitialized
  } = useUser();
  if (!isInitialized) {
    return null;
  }
  if (user) {
    return <MyMenuDropdown />;
  } else {
    return <LogInButton type="normal" />;
  }
};